import React, { useEffect } from 'react'
import { SiteHeader } from '../components/site-header'
import { ApproachSection } from '../components/approach/approach-section'
import { WhyChooseSection } from '../components/approach/why-choose-section'
import { TestimonialsSection } from '../components/shared/testimonials-section'
import { PageHero } from '../components/ui/page-hero'
import { Button } from '../components/ui/button'
import { Link, useLocation } from 'react-router-dom'
import { EventCategory } from '../lib/analytics'
import { safeTrackEvent } from '../lib/analytics-utils'
import { METADATA } from '../components/meta/metadata'

export default function OurApproachPage() {
  const location = useLocation();

  // Set metadata for the page
  useEffect(() => {
    document.title = METADATA.ourApproach.title;
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', METADATA.ourApproach.description);
  }, []);

  const handleBottomCtaClick = () => {
    safeTrackEvent({
      category: EventCategory.Engagement,
      label: 'engagement_our_approach_bottom_cta',
      context: {
        sourcePage: location.pathname,
        destinationPage: '/contact',
        section: 'page_bottom'
      }
    });
  };

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <PageHero
          title="Our Approach"
          description="We combine consulting expertise with systematic knowledge engineering to deliver AI that actually works in your organisation."
          backgroundImage="/images/backgrounds/flickr-32571091933.jpg"
          backgroundAlt="Our Approach"
        />
        <div className="relative">
          <ApproachSection />
          <WhyChooseSection />
          <TestimonialsSection className="bg-primary/5" />
        </div>
        
        {/* Bottom CTA Section */}
        <section className="py-20 pb-32">
          <div className="container">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-semibold tracking-tight mb-6">Ready to Get Started?</h2>
              <p className="text-lg text-muted-foreground mb-8">
                Let's discuss how we can help your organisation move from AI experiments to sustainable capability.
              </p>
              <Button
                onClick={handleBottomCtaClick}
                asChild
                size="lg"
                className="px-8"
              >
                <Link to="/contact">
                  Schedule a Consultation
                </Link>
              </Button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
} 